import { IMockDataOptions } from '@kurtosys/types/api/common/index.js';
import { IRequestOptions } from '@kurtosys/types/api/IRequestOptions';
import stringify from 'json-stable-stringify';

export class MockDataRequest<TRequestBody> {
	url: string;
	mockDataOptions: IMockDataOptions<TRequestBody>;
	key: string;
	requestBody: string;
	response: Response;
	debug: boolean;
	constructor(url: string, options: IRequestOptions<TRequestBody>) {
		this.url = url;
		this.requestBody = stringify(options.body);
		this.mockDataOptions = options.mockData;
		this.debug = options.debug;
		this.key = this.getKey();
	}
	getKey(): string {
		const keyObject = {
			url: this.url,
			requestBody: this.requestBody,
		};
		return stringify(keyObject);
	}
	fetch(): any {
		if (this.mockDataOptions.enabled) {
			if (this.debug) {
				console.info(`Request MOCK DATA: ${this.key}`);
			}
			const { values = [] } = this.mockDataOptions;
			for (const value of values) {
				if (stringify(value.requestBody) === this.requestBody) {
					return value.response;
				}
			}
			return this.mockDataOptions.defaultResponse;
		}
	}
}
